<template>
  <div class="print-purchase-apply">
    <div class="content-wrapper">
      <!-- 标题 -->
      <h2 class="print-title">{{ $t('purchaseApplyDetail.purchaseApplyTitle') }}</h2>

      <!-- 申请单信息 -->
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applyNo') }}</span>
          <span class="info-value">{{ printPurchaseApplyInfo.applyOrderId }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applicant') }}</span>
          <span class="info-value">{{ printPurchaseApplyInfo.endUserName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.contactPhone') }}</span>
          <span class="info-value">{{ printPurchaseApplyInfo.endUserTel }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applyTime') }}</span>
          <span class="info-value">{{ printPurchaseApplyInfo.createTime }}</span>
        </div>
      </div>

      <!-- 采购明细表格 -->
      <table class="print-table">
        <thead>
          <tr>
            <th class="col-name">{{ $t('purchaseApplyDetail.itemName') }}</th>
            <th class="col-code">{{ $t('purchaseApplyDetail.itemCode') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.purchasePrice') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.billingUnitPrice') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.additionalFee') }}</th>
            <th class="col-qty">{{ $t('purchaseApplyDetail.applyQuantity') }}</th>
            <th class="col-qty">{{ $t('purchaseApplyDetail.purchaseQuantity') }}</th>
            <th class="col-remark">{{ $t('purchaseApplyDetail.remark') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in printPurchaseApplyInfo.purchaseApplyDetailVo" :key="index">
            <td>{{ item.resName }}</td>
            <td class="text-center">{{ item.resCode }}</td>
            <td class="text-center">{{ item.purchasePrice }}</td>
            <td class="text-center">{{ parseUnitPrice(item.squarePrice) }}</td>
            <td class="text-center">{{ parseAdditionalFee(item.squarePrice) }}</td>
            <td class="text-center">{{ item.quantity }}</td>
            <td class="text-center">{{ item.purchaseQuantity ? item.purchaseQuantity : '-' }}</td>
            <td>{{ item.remark }}</td>
          </tr>
          <tr class="summary-row">
            <td class="text-center"><strong>{{ $t('purchaseApplyDetail.remark') }}</strong></td>
            <td colspan="5">{{ printPurchaseApplyInfo.description }}</td>
            <td class="text-center"><strong>{{ $t('purchaseApplyDetail.actualPurchaseTotalPrice') }}</strong></td>
            <td class="text-center"><strong>{{ printPurchaseApplyInfo.purchaseTotalPrice }}</strong></td>
          </tr>
          <tr class="sign-row">
            <td colspan="2" class="text-center sign-cell">{{ $t('purchaseApplyDetail.manufacturerSignature') }}</td>
            <td colspan="3"></td>
            <td colspan="1" class="text-center sign-cell">{{ $t('purchaseApplyDetail.time') }}</td>
            <td colspan="2"></td>
          </tr>
          <tr class="sign-row">
            <td colspan="2" class="text-center sign-cell">{{ $t('purchaseApplyDetail.purchaserSignature') }}</td>
            <td colspan="3"></td>
            <td colspan="1" class="text-center sign-cell">{{ $t('purchaseApplyDetail.time') }}</td>
            <td colspan="2"></td>
          </tr>
        </tbody>
      </table>

      <!-- 操作按钮 -->
      <div id="print-btn" class="button-wrapper">
        <el-button type="warning" @click="closePage" style="margin-right:20px;">
          {{ $t('purchaseApplyDetail.cancel') }}
        </el-button>
        <el-button type="primary" @click="printPurchaseApplyDiv">
          <i class="el-icon-printer"></i> {{ $t('purchaseApplyDetail.print') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { listPurchaseApplys } from '@/api/resource/purchaseApplyManageApi'
import { messages } from './purchaseApplyDetailLang'

export default {
  name: 'PrintPurchaseApply',
  i18n: {
    messages
  },
  data() {
    return {
      printPurchaseApplyInfo: {
        applyOrderId: '',
        endUserName: '',
        endUserTel: '',
        description: '',
        purchaseTotalPrice: '',
        purchaseApplyDetailVo: []
      },
      printFlag: '0'
    }
  },
  created() {
    this.initPrintPurchaseApplyDateInfo()
  },
  methods: {
    // 初始化采购申请数据
    initPrintPurchaseApplyDateInfo() {
      const applyOrderId = this.$route.query.applyOrderId
      const resOrderType = this.$route.query.resOrderType

      if (!applyOrderId) {
        this.$message.error('缺少申请单号参数')
        return
      }

      const params = {
        page: 1,
        row: 1,
        applyOrderId: applyOrderId,
        resOrderType: resOrderType
      }

      listPurchaseApplys(params).then(res => {
        if (res.purchaseApplys && res.purchaseApplys.length > 0) {
          this.printPurchaseApplyInfo = res.purchaseApplys[0]
        } else {
          this.$message.error('未找到采购申请信息')
        }
      }).catch(error => {
        console.error('获取采购申请信息失败:', error)
        this.$message.error('获取采购申请信息失败')
      })
    },

    // 解析计费单价（squarePrice中'/'前面的值）
    parseUnitPrice(squarePrice) {
      if (!squarePrice) return '-'
      const parts = String(squarePrice).split('/')
      return parts[0] || '-'
    },
    // 解析附加/固定费用（squarePrice中'/'后面的值）
    parseAdditionalFee(squarePrice) {
      if (!squarePrice) return '-'
      const parts = String(squarePrice).split('/')
      return parts[1] || '-'
    },

    // 打印
    printPurchaseApplyDiv() {
      this.printFlag = '1'
      const printBtn = document.getElementById('print-btn')
      if (printBtn) {
        printBtn.style.display = 'none'
      }
      
      window.print()
      
      // 打印后关闭窗口
      setTimeout(() => {
        window.opener = null
        window.close()
      }, 100)
    },

    // 关闭页面
    closePage() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style scoped>
.print-purchase-apply {
  padding: 20px;
  background: #fff;
  font-family: "Microsoft YaHei", "SimSun", sans-serif;
}

.content-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}

.print-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #333;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  border: 1px solid #333;
  border-radius: 2px;
  padding: 8px 0;
}

.info-item {
  flex: 1 1 25%;
  min-width: 200px;
  padding: 4px 12px;
  box-sizing: border-box;
}

.info-label {
  font-weight: bold;
  color: #333;
  margin-right: 4px;
}

.info-value {
  color: #555;
}

.print-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.print-table th,
.print-table td {
  border: 1px solid #333;
  padding: 8px 6px;
  font-size: 13px;
  word-break: break-all;
}

.print-table thead th {
  background-color: #e8e8e8;
  font-weight: bold;
  text-align: center;
}

.print-table .col-code { width: 100px; }
.print-table .col-price { width: 80px; }
.print-table .col-qty { width: 70px; }
.print-table .col-remark { width: 120px; }

.print-table .summary-row td {
  background-color: #f9f9f9;
}

.print-table .sign-row {
  height: 50px;
}

.print-table .sign-row td {
  vertical-align: middle;
}

.sign-cell {
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.button-wrapper {
  text-align: right;
  margin-top: 30px;
  padding: 20px 0;
}

/* 打印样式 */
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  .print-purchase-apply {
    padding: 0;
  }

  #print-btn {
    display: none !important;
  }

  .print-table th,
  .print-table td {
    font-size: 12px;
    padding: 6px 4px;
  }

  .print-title {
    font-size: 20px;
  }

  .print-table thead th {
    background-color: #e8e8e8 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .print-table .summary-row td {
    background-color: #f9f9f9 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>

